import { SHOW_DELETE_DIALOG, HIDE_DIALOG, SHOW_LOADER, HIDE_LOADER, REMEMBER_LIST, SET_LIST_DATA, SITE_NEW_CONTENT, SCANNED_VALUE } from './mutations_types'
import { DELETE_HANDLER, DELETE_SINGLE_RECORD_HANDLER, RELOAD_NEW_CONTENT } from './actions_types'
import { api } from '../plugins/axios_settings'
const state = {
  showDialog: false,
  deletePayload: {},
  showLoader: false,
  rememberOrder: {},
  ticketState: 0,
  isNewContentAvaliable: false,
  activeSW: {},
  scannedCode: '',
  listOfCustomers: [],
  listOfSuppliers: [],
  // FORM TYPES
  FORM_TYPE: {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    CHECKBOX: 'checkbox',
    SELECT: 'select',
    AUTO_COMPLETE: 'auto_complete',
    COMBOBOX: 'combobox',
    DATE: 'date',
    PASSWORD: 'password',
    NUMBER: 'number',
    DATEPICKER: 'datepicker',
    QUICKADD: 'quickadd',
    TIMEPICKER: 'timepicker',
    FILES: 'files',
    ALERT: 'alert',
    COLORPICKER: 'color',
    BUTTON: 'btn',
    BTNDROPDOWN: 'btnDropdown',
    RADIO: 'radio'
  },
  // ALL THE INDEX PAGE USES
  WORKTYPES_INDEX: {},
  HOLIDAYS_INDEX: {},
  ACTIVITIES_INDEX: {},
  MEMBERS_INDEX: {},
  USERS_INDEX: {},
  PROJECTS_INDEX: {},
  // Common lists
  listOfUsers: [],
  listOfProjects: [],
  listOfCurrentProjects: [],
  listOfWorktypes: [],
  listOfActivities: [],
  listOfHolidays: [],
  // Stamp timer
  isTimerRunning: false,
  currentRunningTime: ''
}

const getters = {
  formType (state) {
    return state.FORM_TYPE
  },
  showDialog (state) {
    return state.showDialog
  },
  deletePayload (state) {
    return state.deletePayload
  },
  getNewContentAvailable (state) {
    return state.isNewContentAvaliable
  },
  getScannedCode (state) {
    return state.scannedCode
  },
  getCustomers (state) {
    return state.listOfCustomers
  },
  getSuppliers (state) {
    return state.listOfSuppliers
  }
}

const actions = {
  [DELETE_HANDLER] ({ commit }, model) {
    return new Promise((resolve, reject) => {
      let modelObj = { data: { ids: model.ids } }
      api.delete(model.url, modelObj).then(() => { resolve() }).catch((error) => { reject(error) })
    })
  },
  [DELETE_SINGLE_RECORD_HANDLER] ({ commit }, model) {
    return new Promise((resolve, reject) => {
      api.delete(model.url).then(() => { resolve() }).catch((error) => { reject(error) })
    })
  },
  [RELOAD_NEW_CONTENT] ({ state, commit }) {
    state.activeSW.waiting.postMessage({ action: 'skipWaiting' })
    commit(RELOAD_NEW_CONTENT)
  },
  /**
   * GET ALL SUPPLIERS
  */
  getSupplierList ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1 AND issupplier eq 1',
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      api.post('customers/query', model)
        .then((response) => {
          let model = { type: 'listOfSuppliers', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  getCustomersList ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        },
        'filter': 'isactive eq 1 AND iscustomer eq 1'
      }
      api.post('customers/query', model)
        .then((response) => {
          let model = { type: 'listOfCustomers', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  }
}

const mutations = {
  [SHOW_DELETE_DIALOG]: (state, data) => {
    state.deletePayload = data
    state.showDialog = true
  },
  [HIDE_DIALOG]: (state) => {
    state.showDialog = false
  },
  [SHOW_LOADER]: (state) => {
    state.showLoader = true
  },
  [HIDE_LOADER]: (state) => {
    state.showLoader = false
  },
  [REMEMBER_LIST]: (state, pagination) => {
    state[pagination.type] = pagination.data
  },
  [SET_LIST_DATA] (state, obj) {
    state[obj.type] = obj.data
  },
  [SITE_NEW_CONTENT]: (state, data) => {
    state.activeSW = data
    state.isNewContentAvaliable = true
  },
  [RELOAD_NEW_CONTENT]: (state) => {
    state.isNewContentAvaliable = false
  },
  [SCANNED_VALUE]: (state, obj) => {
    state.scannedCode = obj
  },
  listValues: (state, obj) => {
    state[obj.type] = obj.data
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
